import React from "react";
import BaseCard from "@/components/cards/BaseCard";

/**
 * CaseStudyCard — proof card for /case-studies index and related strips.
 * Props: { slug, title, blurb, image?, sector?, service?, region? }
 */
const CaseStudyCard = ({ slug, title, blurb, image, sector, service, region }) => {
  const chips = [sector, service, region].filter(Boolean);
  return (
    <BaseCard
      to={`/case-studies/${slug}`}
      variant={image ? "photo" : "flat"}
      image={image}
      eyebrow="Case study"
      title={title}
      blurb={blurb}
      footer={
        chips.length ? (
          <div className="flex flex-wrap gap-2">
            {chips.map((c) => (
              <span
                key={c}
                className="text-[10.5px] uppercase tracking-[0.2em] px-2 py-1 rounded-full"
                style={{
                  background: "rgba(58, 108, 255, 0.1)",
                  border: "1px solid rgba(127, 166, 255, 0.28)",
                  color: "#c9d8ff",
                }}
              >
                {c}
              </span>
            ))}
          </div>
        ) : null
      }
      testid={`case-study-card-${slug}`}
    />
  );
};

export default CaseStudyCard;
